import React, { useRef, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { CHIP_STYLE_TYPES } from '@CommonConstants';

import { setChoiceResult } from '@Services/Editor';

import Chip from '@Components/Common/Chip';

const NextProcessIdChip = ({ processId, choiceId, resultId, nextProcessId }) => {
  const dispatch = useDispatch();
  const processIdRef = useRef(null);

  const onChangeProcessId = useCallback(
    event => {
      const {
        target: { value },
      } = event;

      const checkedNextProcessId = Number(value.replace(/[^0-9]/g, ''));

      dispatch(setChoiceResult({ processId, choiceId, resultId, nextProcessId: checkedNextProcessId }));
    },
    [dispatch],
  );

  return (
    <Chip
      chipRef={processIdRef}
      type={CHIP_STYLE_TYPES.TEXT}
      label="P."
      placeholder="입력"
      value={nextProcessId}
      onChange={onChangeProcessId}
    />
  );
};

NextProcessIdChip.propTypes = {
  processId: PropTypes.number.isRequired,
  choiceId: PropTypes.number.isRequired,
  resultId: PropTypes.number.isRequired,
  nextProcessId: PropTypes.number.isRequired,
};

export default React.memo(NextProcessIdChip);
